import React, { Component } from 'react'
import { motion } from 'framer-motion'
import { Box, Card, Layer } from 'grommet'

/* eslint react/prop-types: 0 */
const BoxRef = React.forwardRef((props, ref) => <Box ref={ref} {...props} />)
BoxRef.displayName = 'BoxRef'
export const MotionBox = motion(BoxRef)

const LayerRef = React.forwardRef((props, ref) => (
  <Layer
    ref={ref}
    animate={false}
    // initial={{ opacity: 0, y: 100 }}
    // animate={{ opacity: 1, y: 0 }}
    // exit={{ opacity: 0, y: 100 }}
    {...props}
  />
))
LayerRef.displayName = 'LayerRef'
export const MotionLayer = motion(LayerRef)

const CardRef = React.forwardRef((props, ref) => <Card ref={ref} {...props} />)
CardRef.displayName = 'CardRef'
export const MotionCard = motion(CardRef)
